export default defineNuxtRouteMiddleware((to) => {
  const { user } = useAuth();
  const { refresh } = useWebPush();

  if (user.value) {
    refresh();
  }
});
